import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@ui/colors'
import Status from '@ui/elements/Status/Status'

export default function RecommendedBadge() {
  const { t } = useTranslation(['ui-steps'])

  return (
    <View className="absolute inset-0 flex h-full w-full flex-1 items-center justify-start">
      <Status
        text={t('ui-steps:option.label.recommended')}
        variant="active"
        typographyProps={{ className: 'uppercase' }}
        colors={{
          front: colors.white,
          back: colors.violet[600],
        }}
        className="relative -top-4 left-0 self-center"
      />
    </View>
  )
}
